import { cn } from '@seen/ui'
import type { JSX } from 'react'

export function IconRelatedArrow({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      className={cn('shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="lch(40% 1 282.863 / 1)"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 1.49902C3 1.22288 2.77614 0.999023 2.5 0.999023C2.22386 0.999023 2 1.22288 2 1.49902H3ZM13.8536 9.67257C14.0488 9.47727 14.0488 9.16068 13.8536 8.96542L10.6716 5.78344C10.4763 5.58817 10.1597 5.58817 9.9645 5.78344C9.7692 5.9787 9.7692 6.29528 9.9645 6.49054L12.7929 9.31897L9.9645 12.1474C9.7692 12.3427 9.7692 12.6593 9.9645 12.8545C10.1597 13.0498 10.4763 13.0498 10.6716 12.8545L13.8536 9.67257ZM2 1.49902V5.31897H3V1.49902H2ZM6.5 9.81897H13.5V8.81897H6.5V9.81897ZM2 5.31897C2 7.80425 4.01472 9.81897 6.5 9.81897V8.81897C4.567 8.81897 3 7.25197 3 5.31897H2Z"></path>
    </svg>
  )
}
